import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import AccessGate from "./AccessGate";
import { ThemeModeProvider } from "./theme/ThemeModeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <AccessGate>
        <App />
      </AccessGate>
    </ThemeModeProvider>
  </React.StrictMode>
)
reportWebVitals()